import React, {useState, useEffect} from 'react';
import {setCookie} from '../../../libs/Cookie';
import {getTemp} from '../../../api';
import {parseUrl} from '../../../libs/UrlUtils';
import {getJson} from "../../../libs/HttpUtils";
import {log} from "../../../logs/action/default/Home";
import Navi from "../../../components/navi";
import {assemble} from "../../../libs/Widget";
import Wp from "../../../components/wp";

let count = null;
let widgetArray = [];
let wpData = null;
let navData = null;

const Home = () => {
    const [open, setOpen] = useState(false);
    const [components, setComponents] = useState([]);
    useEffect(() => {
        (async () => {
            const {data, status} = await getTemp();
            if (status !== 200) return;

            let {navi, wp, widgets, idx} = data;

            const {data: wpResult} = wp ? await getJson(parseUrl(wp)) : '';
            const {data: navResult} = navi && await getJson(parseUrl(navi));
            let {data: idxResult} = idx ? await getJson(parseUrl(idx)) : '';

            wpData = wpResult;
            widgetArray = widgets;
            count = wpResult?.times;
            navData = navResult;
            setOpen(!!wpResult);

            // 初始化cookie
            idxResult && Object.keys(idxResult).forEach((key) => {
                setCookie(key, idxResult[key]);
            });

            // 组装页面组件
            setComponents(assemble(widgetArray));

            // 记录页面打开日志
            log();
        })()
    }, []);

    return (
        <>
            {open && <Wp wpData={wpData} count={count} setOpen={setOpen}/>}

            <div className="home" style={{display: open ? 'none' : 'block'}}>
                {navData && <Navi navDatas={navData}/>}
                <article className="content">
                    {components}
                </article>
            </div>
        </>
    );
}


export default Home;
